import { Box, Button, Flex, Input, LabelledCheckbox, Text } from '@modusign/design-system';

import { Survey } from '@app/containers/Modal/WelcomeSurveyModal';
import { JOB_ROLES } from '@app/containers/Modal/WelcomeSurveyModal/fixtures';

interface JobRoleStepMobileProps {
  nextStep: () => void;
  survey: Survey;
  setSurvey: (update: (survey: Survey) => Survey) => void;
}

function CompanyNameStep({ nextStep, survey, setSurvey }: JobRoleStepMobileProps) {
  const isFormValid = !!survey.companyName && !!survey.jobRole.length;

  function handleCheckboxOnChange(value: string) {
    setSurvey((prev) => {
      if (prev.jobRole.includes(value)) {
        return { ...prev, jobRole: prev.jobRole.filter((v) => v !== value) };
      }
      return { ...prev, jobRole: [...prev.jobRole, value] };
    });
  }

  return (
    <>
      <Box fontSize={2} fontWeight="medium" mt={2}>
        비즈니스 정보에 맞는 모두싸인으로 설정해 드릴게요.
      </Box>
      <Box mt={8}>
        <Box>
          <Text fontWeight="medium">회사명</Text>{' '}
          <Text color="textNeutralLight">(추후 수정 가능)</Text>
        </Box>
        <Box mt={3}>
          <Input
            autoFocus
            height="44px"
            maxLength={30}
            minLength={1}
            placeholder="1자 이상 30자 이내"
            required
            value={survey.companyName}
            onChange={({ currentTarget }) =>
              setSurvey((prev) => ({ ...prev, companyName: currentTarget.value }))
            }
          />
        </Box>
        <Box mt={7}>
          <Text fontWeight="medium">회사 내 역할</Text>{' '}
          <Text color="textNeutralLight">(복수 선택 가능)</Text>
        </Box>
        <Box mt={3}>
          {JOB_ROLES.map(({ title, value }) => (
            <LabelledCheckbox
              checked={survey.jobRole.includes(value)}
              id={value}
              key={value}
              variant="medium"
              onChange={() => handleCheckboxOnChange(value)}
            >
              {title}
            </LabelledCheckbox>
          ))}
        </Box>
        <Flex alignItems="center" justifyContent="end" mt={9}>
          <Button disabled={!isFormValid} ml={6} variant="primary" onClick={nextStep}>
            다음
          </Button>
        </Flex>
      </Box>
    </>
  );
}

export default CompanyNameStep;
